export const enum SnCameraControlType {
  PTZ = 'PTZ',
  Fixed = 'Fixed',
}
